export default __webpack_public_path__ + "static/media/icon-share.3323ae19.svg";